import { CircularProgress } from "@mui/material"
import { lazy, Suspense } from "react"
import { useRoutes } from "react-router-dom"

import AdminRoute from "../components/auth/AdminRoute"
import ProtectedRoute from "../components/auth/ProtectedRoute"
import MainLayout from "../layouts/main"

// Lazy load all page components
const LoginPage = lazy(() => import("../pages/Login"))
const Page404 = lazy(() => import("../pages/Page404"))
const PageError = lazy(() => import("../pages/PageError"))
const BlogDashboard = lazy(() => import("../pages/staff/BlogDashboard"))
const SubmitFormPage = lazy(() => import("../pages/staff/SubmitFormPage"))
const TimeSheet = lazy(() => import("../pages/staff/TimeSheet"))
const UserProfile = lazy(() => import("../pages/UserProfile"))
const UserList = lazy(() => import("../pages/admin/users/UserList"))
const UserDetail = lazy(() => import("../pages/admin/users/UserDetail"))
const UserForm = lazy(() => import("../pages/admin/users/UserForm"))
const TeamManagement = lazy(() => import("../pages/admin/teams/TeamManagement"))
const TeamsView = lazy(() => import("../pages/TeamsView"))

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex items-center justify-center w-full h-screen">
    <CircularProgress />
  </div>
)

export default function Router() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      {useRoutes([
        // Dashboard Routes
        {
          path: "/",
          element: (
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          ),
          children: [
            {
              path: "/",
              element: <TimeSheet />
            },
            {
              path: "time-sheet",
              children: [
                { path: "check", element: <TimeSheet /> },
                { path: "submit", element: <SubmitFormPage /> },
                { path: "blogs", element: <BlogDashboard /> }
              ]
            },
            {
              path: "profile",
              element: <UserProfile />
            },
            {
              path: "teams",
              element: <TeamsView />
            },
            {
              path: "admin",
              children: [
                {
                  path: "users",
                  element: (
                    <AdminRoute>
                      <UserList />
                    </AdminRoute>
                  )
                },
                {
                  path: "users/new",
                  element: (
                    <AdminRoute>
                      <UserForm />
                    </AdminRoute>
                  )
                },
                {
                  path: "users/:staffCode",
                  element: (
                    <AdminRoute>
                      <UserDetail />
                    </AdminRoute>
                  )
                },
                {
                  path: "teams",
                  element: (
                    <AdminRoute>
                      <TeamManagement />
                    </AdminRoute>
                  )
                }
              ]
            }
          ]
        },

        {
          path: "/login",
          element: <LoginPage />
        },

        {
          path: "/error",
          element: <PageError />
        },

        { path: "*", element: <Page404 /> }
      ])}
    </Suspense>
  )
}
